export default "__VITE_ASSET__Dr_pwbbD__"